import Router from '@spaceavocado/svelte-router'
import RouterView from '@spaceavocado/svelte-router/component/view'

import routes from './routes'

Router({ routes })

export default RouterView
